/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Locate Vehicle Icon component.
 */
export const LocateVehicleIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);

  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M11.501 5.80957C11.3291 6.37957 11.2383 6.99485 11.2383 7.61914H7.4834L6.54199 10.333H11.8447C12.1704 11.0114 12.6041 11.6269 13.1377 12.1426H5.80957V16.667H18.4766V13.8887C19.0645 13.8072 19.6891 13.6361 20.2861 13.3467V19.3809C20.2861 19.8785 19.8785 20.2861 19.3809 20.2861H18.4766C17.9789 20.2861 17.5713 19.8785 17.5713 19.3809V18.4766H6.71387V19.3809C6.71387 19.8785 6.30717 20.2861 5.80957 20.2861H4.9043C4.40689 20.2859 4 19.8783 4 19.3809V12.1426L5.88184 6.72363C6.07184 6.18982 6.56985 5.80957 7.16699 5.80957H11.501ZM8.07129 13.0479C8.82208 13.0479 9.42845 13.6536 9.42871 14.4043C9.42871 15.1553 8.82224 15.7617 8.07129 15.7617C7.3204 15.7616 6.71387 15.1552 6.71387 14.4043C6.71413 13.6536 7.32056 13.0479 8.07129 13.0479ZM15.2012 13.4912C15.9159 13.7807 16.6851 13.9431 17.4902 13.9521C17.5445 14.0968 17.5712 14.2416 17.5713 14.4043C17.5713 15.1553 16.9648 15.7617 16.2139 15.7617C15.4631 15.7615 14.8574 15.1551 14.8574 14.4043C14.8575 14.0517 14.9932 13.7354 15.2012 13.4912Z'
        fill={iconColor} />
      <path d='M17.459 11.1361C19.3956 11.1361 20.9656 9.53866 20.9656 7.56807C20.9656 5.59748 19.3956 4 17.459 4C15.5224 4 13.9524 5.59748 13.9524 7.56807C13.9524 9.53866 15.5224 11.1361 17.459 11.1361Z'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap='round' />
      <path d='M19.9856 10.4639L23 13.552'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap='round' />
    </svg>
  );
};

export default LocateVehicleIcon;
